import {} from "@vueuse/core";
import { computed, reactive, ref, set } from "vue";
import {} from "@/components/Workflow/Editor/modules/terminals";
import reportDefault from "@/components/Workflow/Editor/reportDefault";
import { defineScopedStore } from "./scopedStore";
export const useWorkflowStateStore = defineScopedStore("workflowStateStore", () => {
    const inputTerminals = ref({});
    const outputTerminals = ref({});
    const draggingPosition = ref(null);
    const draggingTerminal = ref(null);
    const activeNodeId = ref(null);
    const scale = ref(1);
    const stepPosition = ref({});
    const stepLoadingState = ref({});
    const multiSelectedSteps = ref({});
    const hasChanges = ref(false);
    const report = ref({
        markdown: reportDefault,
    });
    function $reset() {
        inputTerminals.value = {};
        outputTerminals.value = {};
        draggingPosition.value = null;
        draggingTerminal.value = null;
        activeNodeId.value = null;
        scale.value = 1;
        stepPosition.value = {};
        stepLoadingState.value = {};
        multiSelectedSteps.value = {};
        report.value = {
            markdown: reportDefault,
        };
    }
    const getInputTerminalPosition = computed(() => (stepId, inputName) => inputTerminals.value[stepId]?.[inputName]);
    const getOutputTerminalPosition = computed(() => (stepId, outputName) => outputTerminals.value[stepId]?.[outputName]);
    const getStepLoadingState = computed(() => (stepId) => stepLoadingState.value[stepId]);
    const getStepMultiSelected = computed(() => (stepId) => Boolean(multiSelectedSteps.value[stepId]));
    const multiSelectedStepIds = computed(() => Object.entries(multiSelectedSteps.value)
        .filter(([_id, selected]) => selected)
        .map(([id]) => parseInt(id)));
    function clearStepMultiSelection() {
        multiSelectedSteps.value = {};
    }
    function toggleStepMultiSelected(stepId) {
        setStepMultiSelected(stepId, !getStepMultiSelected.value(stepId));
    }
    function setStepMultiSelected(stepId, selected) {
        set(multiSelectedSteps.value, stepId, selected);
    }
    function setInputTerminalPosition(stepId, inputName, position) {
        if (!inputTerminals.value[stepId]) {
            set(inputTerminals.value, stepId, {});
        }
        set(inputTerminals.value[stepId], inputName, position);
    }
    function setOutputTerminalPosition(stepId, outputName, position) {
        if (!outputTerminals.value[stepId]) {
            set(outputTerminals.value, stepId, reactive({}));
        }
        set(outputTerminals.value[stepId], outputName, position);
    }
    function deleteInputTerminalPosition(stepId, inputName) {
        delete inputTerminals.value[stepId]?.[inputName];
    }
    function deleteOutputTerminalPosition(stepId, outputName) {
        delete outputTerminals.value[stepId]?.[outputName];
    }
    function setStepPosition(stepId, position) {
        set(stepPosition.value, stepId, position);
    }
    function deleteStepPosition(stepId) {
        delete stepPosition.value[stepId];
    }
    function deleteStepTerminals(stepId) {
        delete inputTerminals.value[stepId];
        delete outputTerminals.value[stepId];
    }
    function setLoadingState(stepId, loading, error) {
        set(stepLoadingState.value, stepId, { loading, error });
    }
    return {
        inputTerminals,
        outputTerminals,
        draggingPosition,
        draggingTerminal,
        activeNodeId,
        scale,
        report,
        hasChanges,
        stepPosition,
        stepLoadingState,
        $reset,
        getInputTerminalPosition,
        getOutputTerminalPosition,
        getStepLoadingState,
        multiSelectedSteps,
        multiSelectedStepIds,
        getStepMultiSelected,
        clearStepMultiSelection,
        toggleStepMultiSelected,
        setStepMultiSelected,
        setInputTerminalPosition,
        setOutputTerminalPosition,
        deleteInputTerminalPosition,
        deleteOutputTerminalPosition,
        deleteStepPosition,
        deleteStepTerminals,
        setStepPosition,
        setLoadingState,
    };
});
